/**
 * Logs that close the conversation — no next follow-up should be scheduled.
 */
export function isNotInterestedLog(log) {
  if (!log || typeof log !== 'string') return false;
  return /not interested/i.test(log.trim());
}

export function isFutureProspectStage(stage) {
  return stage === 'Future Prospect';
}

/**
 * Whether the Follow Up modal should collect next date + agenda.
 * Terminal stages and "Not Interested" outcomes do not need a next follow-up.
 * Future Prospect always requires a next-contact date (client-told contact date).
 */
export function requiresNextFollowUpFields({ stage, log } = {}) {
  if (isFutureProspectStage(stage)) return true;
  if (stage === 'Deal Closed' || stage === 'Deal Dropped') return false;
  if (isNotInterestedLog(log)) return false;
  return true;
}

/**
 * Next contact date for Future Prospect must be today or later (local day).
 */
export function isValidFutureProspectContactDate(followUpDate) {
  if (!followUpDate) return false;
  const parsed = new Date(followUpDate);
  if (Number.isNaN(parsed.getTime())) return false;
  const dayStart = new Date(parsed);
  dayStart.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dayStart >= today;
}
